export default __webpack_public_path__ + "img/arrow-right-little.916d2f11.svg";